import {ApDynformsConfigFieldset} from '../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {Injectable}               from '@angular/core';
import {NAppSettingsConfigBase}   from './base/n-app-settings-config.base';
import IApplicationSettings = Data.Agronomic.IApplicationSettings;

@Injectable()
export class BoniturConfig extends NAppSettingsConfigBase {
  constructor() {
    super();
  }

  public formBuilder(values: any, applicationSettings: IApplicationSettings, isModalField: boolean,
                     applyBlinkEffectOnInit: boolean): ApDynformsConfigFieldset[] {
    const parameters = applicationSettings.Parameter;
    if (!parameters.slopeShown) {
      return [];
    }
    const applyBlinkEffect = !(isModalField || !applyBlinkEffectOnInit);
    return [
      new ApDynformsConfigFieldset({
        key: 'Agronomy',
        legend: 'Global__Agronomy',
        useMaxWidth: isModalField,
        config: [
          this.generateSlopeControls(parameters, values, applyBlinkEffect)
        ]
      })
    ];
  }

  public updateFormValuesByParameters(values: any, applicationSettings: IApplicationSettings | undefined): void {
    const parameters = applicationSettings.Parameter;
    if (!Number.isFinite(values['ControlFactor'])) {
      values['ControlFactor'] = parameters?.slope?.FirstOrDefault()?.Slope ?? 1;
    }
  }
}
